import {createContext} from 'react'

export const BackdropContext = createContext({
  visible: false,
  setVisible: () => {}
})
